import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../chat.service';
import { leftSlideIn } from '@app/animations';
import { NotificationService } from '@app/notification/notification.service';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { NamePipe } from '@shared/pipes/name.pipe';

@Component({
  selector: 'app-chat-trivia',
  templateUrl: './chat-trivia.component.html',
  styleUrls: ['./chat-trivia.component.scss'],
  animations: [leftSlideIn(300, '-100%')],
  host: { '[@leftSlideIn]': '' },
  imports: [FormsModule, IconComponent, CurrencyComponent, NgOptimizedImage, NamePipe],
})
export class ChatTriviaComponent {
  answer = '';
  constructor(public chatService: ChatService, private notificationsService: NotificationService) {}

  async answerTrivia($event: any) {
    if ($event && $event.key !== 'Enter') {
      return;
    }

    if (this.answer.length < 1) {
      this.notificationsService.error('Answer must be at least 1 character long', 'ERROR');
      return;
    }

    const a = this.answer;
    this.answer = '';
    await this.chatService.answerTrivia(a);
  }
}
